import * as React from 'react';
import { useHistory } from 'react-router-dom';
import * as ReactGA from 'react-ga';

export const GAPageView = () => {
  const history = useHistory();
  React.useEffect(() => {
    
    ReactGA.set({ page: history.location.pathname });
    ReactGA.pageview(history.location.pathname);

    const unregisterHistoryListner = history.listen((location) => {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    });
    return () => {
      unregisterHistoryListner();
    }
  }, []);
  
  return null;
}


// WEBPACK FOOTER //
// ./src/modules/reactGA.ts